export const Footer = () =>{
    return (
        <>
            <hr className="mt-3" />
            <footer className="text-white text-center">Pujan Gautam &copy; Copyright 2023. All Rights Reserved.</footer>
        </>

    );
}